<template>
  <FormComponent :app="getApp" :onSubmit="submit"></FormComponent>
</template>

<script>
import FormComponent from './form-component.vue';

export default {
  name: 'EditApp',
  components: {
    FormComponent,
  },

  created() {
    this.$store.dispatch('app/getApp', this.$route.params.appId);
  },
  computed: {
    getApp() {
      return this.$store.state.app.app;
    },
  },
  methods: {
    submit() {
      this.$store.dispatch('app/update', {
        id: this.$route.params.appId,
        body: this.getApp,
      });
    },
  },
};
</script>
